import { render, staticRenderFns } from "./CaseFiles.vue?vue&type=template&id=5d14ff38"
import script from "./CaseFiles.vue?vue&type=script&lang=js"
export * from "./CaseFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports